module.exports = __webpack_public_path__ + "media/2_2-3.7c358f31.mp3";